import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import collaborationLogo from '../../../images/features/ana/collaboration_logo.png';
import titleImage from '../../../images/features/ana/title.png';
import Link from './Link';
import StripeLine from './StripeLine';
import airplaneImage from '../../../images/features/ana/airplane.png';
import headLeftImage from '../../../images/features/ana/head_left.png';
import headRightImage from '../../../images/features/ana/head_right.png';
import { styles as containerStyles } from '../styles/container';
import { COVID_19_NEWS } from '../variables';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    ...containerStyles(theme),
    maxWidth: theme.breakpoints.values.lg,
    margin: 'auto',
  },
  airplaneImage: {
    position: 'absolute',
    left: '2%',

    width: '20%',
    top: '3%',
    [theme.breakpoints.up('sm')]: {
      width: '15%',
      top: '15%',
    },
  },
  headLeftImage: {
    position: 'absolute',
    left: '-2%',

    width: '22%',
    bottom: '10%',
    [theme.breakpoints.up('sm')]: {
      left: '-1%',
      width: '17%',
      bottom: '15%',
    },
  },
  headRightImage: {
    position: 'absolute',
    right: '-5%',

    width: '25%',
    bottom: '10%',
    [theme.breakpoints.up('sm')]: {
      width: '21%',
      bottom: '20%',
      right: '-3%',
    },
  },
  card: {
    boxShadow: '0px 3px 6px #00000029',
    position: 'relative',
    height: 500,
    backgroundColor: 'white',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: '40px 50px',
    },
  },
  logoImage: {
    margin: '0 0 18px',

    width: '80%',
    [theme.breakpoints.up('sm')]: {
      width: '35%',
    },
  },
  containerTitle: {
    textAlign: 'center',
  },
  titleImage: {
    margin: '8px 0',

    width: '92%',
    [theme.breakpoints.up('sm')]: {
      width: '52%',
    },
  },
  description: {
    padding: theme.spacing(0, 0.5),
    textAlign: 'center',
    '& p': {
      fontSize: theme.typography.pxToRem(14),
      paddingBottom: '1rem',
      '&:not(:last-child)': {
        paddingBottom: 0,
        [theme.breakpoints.up('sm')]: {
          paddingBottom: '1rem',
        },
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: 1.3,
      },
    },
  },
  attention: {
    margin: '18px 0',
    color: '#004AD6',
    textDecoration: 'underline',
  },
  link: {
    [theme.breakpoints.up('sm')]: {
      marginTop: 15,
    },
    '& > span': {
      textDecoration: 'underline',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
  },
}));

const Head = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <StripeLine />
        <div className={classes.content}>
          <img
            src={collaborationLogo}
            alt="collaboration_logo"
            className={classes.logoImage}
          />
          <h1 className={classes.containerTitle}>
            <img
              src={titleImage}
              alt="ANAトラベラーズとのコラボおてつたびStart!!"
              className={classes.titleImage}
            />
          </h1>
          <div className={classes.description}>
            <Typography>
              <span className="d-inline-block">
                この度、おてつたびとANAトラベラーズが
              </span>
              <span className="d-inline-block">連携したプロジェクト開始！</span>
            </Typography>
            <Typography>
              <span className="d-inline-block">
                今までよりもさらに、リーズナブルで気軽に
              </span>
              <span className="d-inline-block">
                知らない地域へ旅に出かけよう
              </span>
            </Typography>
          </div>
          <Link href={COVID_19_NEWS} className={classes.link}>
            <span>新型コロナウイルス</span>
            <span>感染予防のためのご協力のお願い</span>
          </Link>
        </div>
        <StripeLine />
        <img
          src={airplaneImage}
          alt="airplane_image"
          className={classes.airplaneImage}
        />
        <img
          src={headLeftImage}
          alt="head_left_image"
          className={classes.headLeftImage}
        />
        <img
          src={headRightImage}
          alt="head_right_image"
          className={classes.headRightImage}
        />
      </div>
    </div>
  );
};

export default Head;
